import React, { useState, useEffect } from 'react';

const CountdownTimer: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: 28,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const getTargetTime = () => {
            const savedTargetTime = localStorage.getItem('countdownTargetTime');
            if (savedTargetTime) {
                const targetTime = new Date(parseInt(savedTargetTime));
                const now = new Date().getTime();
                
                if (targetTime.getTime() <= now) {
                    const newTargetTime = new Date();
                    newTargetTime.setDate(newTargetTime.getDate() + 28);
                    localStorage.setItem('countdownTargetTime', newTargetTime.getTime().toString());
                    return newTargetTime;
                }
                
                return targetTime;
            } else {
                const newTargetTime = new Date();
                newTargetTime.setDate(newTargetTime.getDate() + 28);
                localStorage.setItem('countdownTargetTime', newTargetTime.getTime().toString());
                return newTargetTime;
            }
        };

        const targetTime = getTargetTime();

        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetTime.getTime() - now;

            if (distance < 0) {
                const newTargetTime = new Date();
                newTargetTime.setDate(newTargetTime.getDate() + 28);
                localStorage.setItem('countdownTargetTime', newTargetTime.getTime().toString());
                setTimeLeft({ days: 28, hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setTimeLeft({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="fixed top-2 right-2 sm:top-4 sm:right-4 z-50">
            <div className="bg-black bg-opacity-90 rounded-lg p-2 sm:p-3 shadow-2xl max-w-xs sm:max-w-none">
                <div className="flex items-center justify-center mb-1 sm:mb-2">
                    <div className="flex items-center space-x-1">
                        <div className="w-1 h-1 sm:w-1.5 sm:h-1.5 bg-red-500 rounded-full animate-pulse"></div>
                        <span className="text-xs sm:text-xs font-medium text-white text-opacity-90 tracking-wider">OFERTA LIMITADA</span>
                    </div>
                </div>
                
                <div className="flex items-center space-x-1 mb-1 sm:mb-2">
                    <div className="text-center">
                        <div className={`text-sm sm:text-lg font-mono font-bold ${
                            timeLeft.days <= 7 ? 'text-red-400' : 'text-green-400'
                        }`}>
                            {timeLeft.days.toString().padStart(2, '0')}
                        </div>
                        <div className="text-xs text-white text-opacity-70 font-mono tracking-wider">DÍAS</div>
                    </div>
                    
                    <div className="text-green-400 text-xs sm:text-sm font-bold animate-pulse">:</div>
                    
                    <div className="text-center">
                        <div className={`text-sm sm:text-lg font-mono font-bold ${
                            timeLeft.days <= 1 ? 'text-red-400' : 'text-green-400'
                        }`}>
                            {timeLeft.hours.toString().padStart(2, '0')}
                        </div>
                        <div className="text-xs text-white text-opacity-70 font-mono tracking-wider">HRS</div>
                    </div>
                    
                    <div className="text-green-400 text-xs sm:text-sm font-bold animate-pulse">:</div>
                    
                    <div className="text-center">
                        <div className={`text-sm sm:text-lg font-mono font-bold ${
                            timeLeft.hours <= 1 ? 'text-red-400' : 'text-green-400'
                        }`}>
                            {timeLeft.minutes.toString().padStart(2, '0')}
                        </div>
                        <div className="text-xs text-white text-opacity-70 font-mono tracking-wider">MIN</div>
                    </div>
                    
                    <div className="text-red-400 text-xs sm:text-sm font-bold animate-pulse">:</div>
                    
                    <div className="text-center">
                        <div className="text-sm sm:text-lg font-mono font-bold text-red-400">
                            {timeLeft.seconds.toString().padStart(2, '0')}
                        </div>
                        <div className="text-xs text-white text-opacity-70 font-mono tracking-wider">SEG</div>
                    </div>
                </div>
                
                <div className="text-center">
                    <div className="text-xs text-white text-opacity-80 font-mono tracking-wide">
                        LIBRO + SISTEMA COMPLETO
                    </div>
                    <div className="text-xs text-orange-400 font-mono font-bold tracking-wider">
                        50% DESCUENTO DE POR VIDA
                    </div>
                </div>
                
                <div className="mt-1 sm:mt-2">
                    <div className="w-full bg-white bg-opacity-20 rounded-full h-1">
                        <div 
                            className="bg-gradient-to-r from-green-400 via-yellow-400 to-red-400 h-1 rounded-full transition-all duration-1000 ease-out"
                            style={{ width: `${(timeLeft.days / 28) * 100}%` }}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountdownTimer;